import { render, staticRenderFns } from "./parkdriverv1.vue?vue&type=template&id=23201d66&"
import script from "./parkdriverv1.vue?vue&type=script&lang=js&"
export * from "./parkdriverv1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports